import TabView from "../../../MUI_components/tab";
import ReturnWithBill from "./returnWithBill";
import ReturnWithoutBill from "./returnWithoutBill";

const SalesReturn = (props) => {
  const tabView = [
    {
      title: "Return With Bill",
      component: <ReturnWithBill {...props} />,
    },
    {
      title: "Return Without Bill",
      component: <ReturnWithoutBill {...props} />,
    },
  ];
  return (
    <div style={{ margin: 20 }}>
      <TabView tabViews={tabView} />
    </div>
  );
};

export default SalesReturn;
